export default __webpack_public_path__ + "images/image4.jpg";